import React, { useState } from 'react';
import './LogoFormContainer.css';
import LoginForm from './LoginForm';
import ForgotPasswordForm from './ForgotPasswordForm';


export default function LogoFormContainer({ handleLoginSubmit, handleEnter, setEmail, setPassword, t, ctx, realm = 'user' }) {
    // State to manage the visibility of the forgot password form or login fomr
    const [showForgotPassword, setShowForgotPassword] = useState(false);

    //============================================================================================================
    //Defines a container with the shipperform logo and a form for login or forgot password
    //If showForgotPassword is true, it will show the ForgotPasswordForm, otherwise it will show the LoginForm
    //============================================================================================================
    return (
        <div className="logo-form-container">
            <div className="logo-container">
                <img
                    src="./images/LogoShipperform.png"
                    alt="logo_project"
                    className="logo-image"
                />
            </div>
            <div className="form-container">
                {showForgotPassword ? ( // If true, show forgot password form
                    <ForgotPasswordForm
                        onBackToLogin={() => setShowForgotPassword(false)}
                        ctx={ctx}
                        t={t}
                        realm={realm}
                    />
                ) : ( // If false, show login form
                    <LoginForm
                        onForgotPassword={() => setShowForgotPassword(true)}
                        handleLoginSubmit={handleLoginSubmit}
                        handleEnter={handleEnter}
                        setEmail={setEmail}
                        setPassword={setPassword}
                        t={t}
                        ctx={ctx}
                    />
                )}
            </div>
        </div>
    );
}
